import moment from "moment/moment";
import { useEffect, useState } from "react";
// import CardHeaderDashboardOnOff from "../../../utils/cardHeaderDashboardOnOff";
import { useOutletContext } from "react-router-dom";
import { requestToServer } from "../../utils/appUtils";
// import { GetConnMC } from "../../../../api";
import { MainArea, MainAreaBody, MainAreaHeader } from "../../layout/MainArea";
import { GetApkKonsul } from "../../../api";
import CardHeaderDashboard from "../../home/cardHeaderDashboard";

const ROUTE_URL = "/get_conn_mc";

const APKKonsul = (props) => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(3);
    const [date, setDate] = useState();
    const [onoff, setOnoff] = useState(props.butchState);
    const [loadingStatus, setLoadingStatus] = useState(true)
    const [serverData, setServerData] = useState(null);
    const token = localStorage.getItem('token')

    const { showErrorPage, messageBox } = useOutletContext();
    let servicesPrev = [
        { id: 1, name: "SUPL по SSL", status: status, date: date, key: "check_ssl"},
        { id: 2, name: "SUPL без SSL", status: status, date: date, key: "check_nossl"},
        { id: 3, name: "Загрузка станций сотовой связи", status: status, date: date, key: "source_0"},
        { id: 4, name: "Загрузка данных с G+", status: status, date: date, key: "source_1"},
        { id: 5, name: "Загрузка данных с Binr-M", status: status, date: date, key: "source_2"},
        { id: 6, name: "Загрузка данных с Binr-T", status: status, date: date, key: "source_4"},
    ];

    const [services, setServices] = useState(servicesPrev)
    useEffect(() => {
        // if (onoff) {
            // window.timer = setInterval(async () => {
                // if (onoff) {
                    GetApkKonsul(token).then((e) => {
                        let data =  e.data;
                        let arr = []
                        servicesPrev.forEach((d) => {
                            arr.push({
                                 id: d.id, name: d.name, status: data[d.key].state, date: data[d.key].created_at ?? "Ошибка", key: d.key
                            })
                        });
                        console.log(arr);
                            setServices(arr)
                            setLoadingStatus(false)
                    })

                // } else {
                //     setLoadingStatus(false)
                //     clearInterval(window.timer);
                // }
            // }, 5000);
        // } else {
        //     clearInterval(window.timer);
        // }
    }, [])

  

    const handleClick = (event) => {
        if (loading) return;
        event.preventDefault();
        event.target.blur();
        setLoadingStatus(true);
        GetApkKonsul(token).then((e) => {
            let data =  e.data;
            let arr = []
            servicesPrev.forEach((d) => {
                arr.push({
                     id: d.id, name: d.name, status: data[d.key].state, date: data[d.key].created_at ?? "Ошибка", key: d.key
                })
            });
            console.log(arr);
                setServices(arr)
                setLoadingStatus(false)
        })
        setTimeout(() => {
            setLoadingStatus(false);
        }, 1000);
    }

    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }

    return (
        <MainArea>
                <MainAreaBody>
        <div className={classCard} style={styleCard}>
        <CardHeaderDashboard loading={loading} onClick={handleClick}>АПК Консул
        </CardHeaderDashboard>

            <div className="card-body" style={{ fontSize: "0.85rem" }}>
                {(
                    services.map((item, index, array) => {
                        return (
                            <div key={item.id} className={`gap-2 col-12 d-flex align-items-center ${index == 0 ? "" : "mt-1"}`}>
                                {loadingStatus ? (
                                    <div style={{ width: "1.25em", height: "1.25em", margin: `6.5px 0px` }} className=" spinner-border spinner-border-sm text-primary"></div>
                                ) : (
                                    <i className={`fs-5 ${item.status === 1 ? "bi-x-circle-fill text-danger" : "bi-check-circle-fill text_green"}`}></i>
                                )}
                                <div>
                                    <span className="link-info">
                                        {item.href ? <a className="link-info" href={`${item.href}`}>{item.name}</a> : item.name} - <small>{moment(item.date).isValid() ? moment.utc(item.date).local().format("DD.MM.YYYY HH:mm:ss") : item.date}</small>
                                    </span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
        </MainAreaBody>
        </MainArea>
    );
}

export default APKKonsul;